import { render, staticRenderFns } from "./CatchErrorEvent.vue?vue&type=template&id=50ea6c4f&scoped=true&"
import script from "./CatchErrorEvent.vue?vue&type=script&lang=js&"
export * from "./CatchErrorEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ea6c4f",
  null
  
)

export default component.exports